import { Box, Container, Theme, Toolbar, useMediaQuery } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { ContractorDrawerContent, ContractorDrawerFooter, Drawer, DRAWER_WIDTH } from './Drawer';
import MainAppBar from './Header/MainAppBar';
import { useLayoutContext } from './useLayoutContext';
import { Outlet } from "react-router-dom";

interface InspectorDashboardPageProps extends React.PropsWithChildren {
  footer?: React.ReactNode;
}

const DashboardLayout: React.FC<InspectorDashboardPageProps> = ({ children, footer }) => {
  const {
    drawerVisible,
    drawerOpen,
    setDrawerVisible,
    setDrawerContent,
    setDrawerFooter,
    printMode,
  } = useLayoutContext();
  const [drawerWidth, setDrawerWidth] = useState(DRAWER_WIDTH);
  const matchUpLG = useMediaQuery((theme: Theme) => theme.breakpoints.up('lg'));

  useEffect(() => {
    setDrawerContent(<ContractorDrawerContent />);
    setDrawerFooter(<ContractorDrawerFooter />);
  }, [setDrawerContent, setDrawerFooter]);

  useEffect(() => {
    setDrawerVisible(drawerVisible);
  }, [drawerVisible, setDrawerVisible]);

  useEffect(() => {
    // adjust drawer width based on visibility and screen size
    setDrawerWidth(
      matchUpLG
        ? drawerVisible && drawerOpen ? DRAWER_WIDTH : 0
        : 0,
    );
  }, [drawerVisible, drawerOpen, setDrawerWidth, matchUpLG]);

  return (
    <Box>
      <MainAppBar width={drawerWidth} />

      {drawerVisible && (
        <Box
          component="nav"
          sx={{ width: drawerWidth }}
          aria-label="dashboard menu"
        >
          <Drawer />
        </Box>
      )}

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          ml: { sm: `${drawerWidth}px` },
        }}
      >
        {!printMode && <Toolbar sx={{ mb: 2 }} />}

        <Container maxWidth={printMode ? false : 'lg'}>
          {children}
          <Outlet />
        </Container>

        <Box pt={2}>{footer}</Box>
      </Box>
    </Box>
  );
};

export default DashboardLayout;
